export const toThousandsFormat = (value: string | number): string => {
  const str = String(value).trim()
  const match = str.match(/^(-?)(\d+)([.,]\d+)?$/)

  if (!match) {
    return str
  }

  const [, sign, integer, fraction = ''] = match
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return `${sign}${grouped}${fraction}`
}
